import { Controller } from "@hotwired/stimulus";

// Toggles the collapsible Order Summary on the mobile payment page: shows/hides
// the line-item + fee breakdown and rotates the chevron.
export default class extends Controller {
  static targets = ["body", "chevron"];

  toggle() {
    this.bodyTarget.classList.toggle("d-none");
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("is-open");
    }
  }
}
